/* ==========================================================================
   arije - Comparateur produits (v1)
   Aucune dependance. Charge en defer depuis snippets/meta-tags.liquid.
   Configuration injectee dans window.ArijeCompareConfig.
   ========================================================================== */

(function () {
  'use strict';

  var CFG = window.ArijeCompareConfig || {};
  var STR = CFG.strings || {};
  var MAX = CFG.max || 3;
  var KEY = 'arije:compare:v1';
  var CACHE_PREFIX = 'arije:compare:data:v2:';
  var TTL = 30 * 24 * 60 * 60 * 1000; /* 30 jours */
  var CACHE_TTL = 10 * 60 * 1000; /* 10 minutes */

  var memory = null;

  /* ------------------------------------------------------------------ */
  /* Utilitaires                                                         */
  /* ------------------------------------------------------------------ */

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function track(name, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: name };
      for (var k in params) {
        if (Object.prototype.hasOwnProperty.call(params, k)) payload[k] = params[k];
      }
      window.dataLayer.push(payload);
    } catch (e) {}
  }

  function rootUrl() {
    return String(CFG.rootUrl || '/').replace(/\/$/, '');
  }

  /* iOS : iPhone, iPod, iPad. Depuis iPadOS 13 l'iPad se declare comme un Mac,
     on le distingue au nombre de points tactiles. Un Mac de bureau renvoie 0. */
  function isIOS() {
    var ua = navigator.userAgent || '';
    if (/iPad|iPhone|iPod/.test(ua)) return true;
    return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  }

  /* Feuille de partage native : reservee a iOS. Sur Android et sur ordinateur
     on garde la copie du lien, plus previsible. */
  function canNativeShare() {
    return isIOS() && typeof navigator.share === 'function';
  }

  /* ------------------------------------------------------------------ */
  /* Store (localStorage, avec repli memoire)                            */
  /* ------------------------------------------------------------------ */

  var Store = {
    read: function () {
      try {
        var raw = JSON.parse(window.localStorage.getItem(KEY) || 'null');
        if (!raw || raw.v !== 1 || !Array.isArray(raw.items)) return memory || [];
        if (Date.now() - (raw.updatedAt || 0) > TTL) {
          Store.write([]);
          return [];
        }
        memory = raw.items;
        return raw.items;
      } catch (e) {
        return memory || [];
      }
    },

    write: function (items) {
      memory = items;
      try {
        window.localStorage.setItem(
          KEY,
          JSON.stringify({ v: 1, updatedAt: Date.now(), items: items })
        );
      } catch (e) {
        /* Safari navigation privee : on conserve le repli memoire. */
      }
      document.dispatchEvent(
        new CustomEvent('compare:change', { detail: { items: items } })
      );
    },

    has: function (handle) {
      return Store.read().some(function (i) {
        return i.handle === handle;
      });
    },

    add: function (item) {
      var items = Store.read().slice();
      if (!item.handle) return 'error';
      if (Store.has(item.handle)) return 'exists';
      if (items.length >= MAX) return 'full';
      item.addedAt = Date.now();
      items.push(item);
      Store.write(items);
      return 'added';
    },

    remove: function (handle) {
      Store.write(
        Store.read().filter(function (i) {
          return i.handle !== handle;
        })
      );
      return 'removed';
    },

    toggle: function (item) {
      return Store.has(item.handle) ? Store.remove(item.handle) : Store.add(item);
    },

    clear: function () {
      Store.write([]);
    }
  };

  /* ------------------------------------------------------------------ */
  /* Toast                                                               */
  /* ------------------------------------------------------------------ */

  var toastTimer;

  function toast(message) {
    var el = document.querySelector('[data-cmp-toast]');
    if (!el || !message) return;
    el.textContent = message;
    el.hidden = false;
    window.requestAnimationFrame(function () {
      el.classList.add('is-visible');
    });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () {
        el.hidden = true;
      }, 250);
    }, 2600);
  }

  /* ------------------------------------------------------------------ */
  /* Boutons                                                             */
  /* ------------------------------------------------------------------ */

  function syncToggles() {
    var items = Store.read();
    qsa('[data-cmp-toggle]').forEach(function (btn) {
      var on = items.some(function (i) {
        return i.handle === btn.getAttribute('data-handle');
      });
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('title', on ? STR.remove || '' : STR.add || '');
      var label = btn.querySelector('[data-cmp-label]');
      if (label) label.textContent = on ? STR.remove || '' : STR.add || '';
    });
  }

  function handleToggle(btn) {
    var item = {
      handle: btn.getAttribute('data-handle'),
      id: btn.getAttribute('data-id'),
      title: btn.getAttribute('data-title'),
      vendor: btn.getAttribute('data-vendor'),
      image: btn.getAttribute('data-image'),
      url: btn.getAttribute('data-url')
    };
    var source = btn.getAttribute('data-context') || 'pdp';
    var result = Store.toggle(item);

    if (result === 'full') {
      toast(STR.limit);
      track('compare_limit_reached', { attempted_item_id: item.id });
      return;
    }
    if (result === 'added') {
      toast(STR.added);
      track('compare_add', {
        item_id: item.id,
        item_name: item.title,
        item_brand: item.vendor,
        compare_count: Store.read().length,
        source: source
      });
    }
    if (result === 'removed') {
      toast(STR.removed);
      track('compare_remove', {
        item_id: item.id,
        item_name: item.title,
        item_brand: item.vendor,
        compare_count: Store.read().length,
        source: source
      });
    }
  }

  /* ------------------------------------------------------------------ */
  /* Barre flottante                                                     */
  /* ------------------------------------------------------------------ */

  function renderBar() {
    var bar = document.querySelector('[data-cmp-bar]');
    if (!bar) return;

    var items = Store.read();
    var slots = bar.querySelector('[data-cmp-slots]');
    var count = bar.querySelector('[data-cmp-count]');

    if (!items.length) {
      bar.classList.remove('is-visible');
      setTimeout(function () {
        if (!Store.read().length) bar.hidden = true;
      }, 260);
      return;
    }

    bar.hidden = false;
    window.requestAnimationFrame(function () {
      bar.classList.add('is-visible');
    });

    var html = '';
    items.forEach(function (it) {
      html +=
        '<li class="cmp-bar__slot">' +
        '<a href="' + esc(it.url) + '">' +
        (it.image
          ? '<img src="' + esc(it.image) + '" alt="' + esc(it.title) + '" width="104" height="104" loading="lazy">'
          : '') +
        '</a>' +
        '<button type="button" class="cmp-bar__remove" data-cmp-remove data-handle="' +
        esc(it.handle) +
        '" aria-label="' +
        esc((STR.removeItem || '') + ' ' + (it.title || '')) +
        '">&times;</button>' +
        '</li>';
    });
    for (var i = items.length; i < MAX; i++) {
      html += '<li class="cmp-bar__slot cmp-bar__slot--empty" aria-hidden="true"></li>';
    }

    if (slots) slots.innerHTML = html;
    if (count) count.textContent = ' (' + items.length + ')';
  }

  /* ------------------------------------------------------------------ */
  /* Donnees produit (endpoint Liquid ?view=compare-data)                */
  /*                                                                     */
  /* IMPORTANT : ne JAMAIS envoyer l'en-tete Accept: application/json.   */
  /* Shopify renverrait alors sa representation JSON native du produit   */
  /* (sans metafields) au lieu du template product.compare-data.liquid.  */
  /* ------------------------------------------------------------------ */

  function fetchProduct(handle) {
    var cacheKey = CACHE_PREFIX + handle;
    try {
      var cached = JSON.parse(window.sessionStorage.getItem(cacheKey) || 'null');
      if (cached && cached.d && Date.now() - cached.t < CACHE_TTL) {
        return Promise.resolve(cached.d);
      }
    } catch (e) {}

    var url = rootUrl() + '/products/' + encodeURIComponent(handle) + '?view=compare-data';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (text) {
        var data = JSON.parse(text);
        if (!data || typeof data.comparable === 'undefined') {
          throw new Error('Reponse inattendue');
        }
        try {
          window.sessionStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), d: data }));
        } catch (e) {}
        return data;
      })
      .catch(function () {
        return { handle: handle, comparable: false, error: true };
      });
  }

  /* ------------------------------------------------------------------ */
  /* Page comparateur                                                    */
  /* ------------------------------------------------------------------ */

  var GROUP_ORDER = ['essentiel', 'mouvement', 'boitier', 'cadran', 'bracelet', 'joaillerie', 'services'];

  function readFields(root) {
    var node = root.querySelector('[data-cmp-fields]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  function cellValue(data, key) {
    if (!data) return '';
    switch (key) {
      case '__vendor':
        return data.vendor || '';
      case '__sku':
        return data.sku || '';
      case '__price':
        return data.price || '';
      case '__availability':
        return data.available ? STR.inStock || '' : STR.onRequest || '';
      default:
        return (data.specs && data.specs[key]) || '';
    }
  }

  function headCell(data, item) {
    var url = (data && data.url) || (item && item.url) || '#';
    var title = (data && data.title) || (item && item.title) || '';
    var vendor = (data && data.vendor) || (item && item.vendor) || '';
    var image = (data && data.image) || (item && item.image) || '';
    var price = (data && data.price) || '';
    var available = data && data.available;
    var ctaLabel = available ? STR.viewProduct || '' : STR.contact || '';
    var ctaUrl = available
      ? url
      : rootUrl() + '/pages/contact?sku=' + encodeURIComponent((data && data.sku) || '');

    return (
      '<th scope="col" class="cmp-head-cell">' +
      '<button type="button" class="cmp-head-cell__remove" data-cmp-remove data-handle="' +
      esc(item.handle) +
      '" aria-label="' + esc((STR.removeItem || '') + ' ' + title) + '">&times;</button>' +
      '<a class="cmp-head-cell__media" href="' + esc(url) + '">' +
      (image ? '<img src="' + esc(image) + '" alt="' + esc(title) + '" loading="lazy">' : '') +
      '</a>' +
      '<span class="cmp-head-cell__vendor">' + esc(vendor) + '</span>' +
      '<a class="cmp-head-cell__title" href="' + esc(url) + '">' + esc(title) + '</a>' +
      (price ? '<span class="cmp-head-cell__price">' + esc(price) + '</span>' : '') +
      '<a class="cmp-head-cell__cta" href="' + esc(ctaUrl) + '">' + esc(ctaLabel) + '</a>' +
      '</th>'
    );
  }

  function emptyHeadCell(root) {
    var href = root.getAttribute('data-browse-url') || rootUrl() + '/collections/all';
    return (
      '<th scope="col" class="cmp-head-cell">' +
      '<a class="cmp-head-cell__slot" href="' + esc(href) + '">' + esc(STR.emptySlot || '') + '</a>' +
      '</th>'
    );
  }

  function renderTable(root) {
    var items = Store.read();
    var body = root.querySelector('[data-cmp-body]');
    var emptyState = root.querySelector('[data-cmp-empty]');
    var tools = root.querySelector('[data-cmp-tools]');
    if (!body) return;

    if (!items.length) {
      body.innerHTML = '';
      if (emptyState) emptyState.hidden = false;
      if (tools) tools.hidden = true;
      return;
    }

    if (emptyState) emptyState.hidden = true;
    if (tools) tools.hidden = false;
    body.innerHTML = '<p class="cmp-loading">' + esc(STR.loading || '') + '</p>';

    Promise.all(
      items.map(function (i) {
        return fetchProduct(i.handle);
      })
    ).then(function (results) {
      /* Securite : toute fiche non comparable (Rolex, erreur) est ecartee. */
      var pairs = [];
      items.forEach(function (item, idx) {
        var data = results[idx];
        if (data && data.comparable === true) pairs.push({ item: item, data: data });
      });

      if (!pairs.length) {
        body.innerHTML = '';
        if (emptyState) emptyState.hidden = false;
        if (tools) tools.hidden = true;
        return;
      }

      var fields = [
        { key: '__vendor', group: 'essentiel', label: STR.brand || '' },
        { key: '__sku', group: 'essentiel', label: STR.reference || '' },
        { key: '__price', group: 'essentiel', label: STR.price || '' },
        { key: '__availability', group: 'essentiel', label: STR.availability || '' }
      ].concat(readFields(root));

      var groups = STR.groups || {};
      var html = '<table class="cmp-table"><caption>' + esc(STR.barLabel || '') + '</caption><thead><tr>';
      html += '<td class="cmp-col-label"></td>';
      pairs.forEach(function (p) {
        html += headCell(p.data, p.item);
      });
      for (var s = pairs.length; s < MAX; s++) {
        html += emptyHeadCell(root);
      }
      html += '</tr></thead><tbody>';

      GROUP_ORDER.forEach(function (groupId) {
        var groupFields = fields.filter(function (f) {
          return f.group === groupId;
        });
        var rows = '';
        groupFields.forEach(function (f) {
          var values = pairs.map(function (p) {
            return cellValue(p.data, f.key);
          });
          var hasValue = values.some(function (v) {
            return String(v).trim() !== '';
          });
          if (!hasValue) return;

          var identical = values.every(function (v) {
            return String(v).trim() === String(values[0]).trim();
          });

          rows +=
            '<tr class="cmp-row" data-identical="' + (identical && pairs.length > 1 ? 'true' : 'false') + '">' +
            '<th scope="row" class="cmp-col-label">' + esc(f.label) + '</th>';
          values.forEach(function (v) {
            var empty = String(v).trim() === '';
            rows +=
              '<td class="cmp-cell' + (empty ? ' cmp-value--empty' : '') + '">' +
              (empty ? '&mdash;' : esc(v)) +
              '</td>';
          });
          for (var e = pairs.length; e < MAX; e++) {
            rows += '<td class="cmp-cell cmp-value--empty"></td>';
          }
          rows += '</tr>';
        });

        if (rows) {
          html +=
            '<tr class="cmp-group-row"><th scope="colgroup" colspan="' + (MAX + 1) + '">' +
            esc(groups[groupId] || '') +
            '</th></tr>' +
            rows;
        }
      });

      html += '</tbody></table>';
      body.innerHTML = '<div class="cmp-scroller">' + html + '</div>';
      applyDiffFilter(root);

      track('compare_view', {
        compare_count: pairs.length,
        items: pairs.map(function (p) {
          return p.item.handle;
        })
      });
    });
  }

  function applyDiffFilter(root) {
    var input = root.querySelector('[data-cmp-diff]');
    var only = !!(input && input.checked);
    qsa('.cmp-row', root).forEach(function (row) {
      var identical = row.getAttribute('data-identical') === 'true';
      row.classList.toggle('is-hidden', only && identical);
    });
  }

  /* ------------------------------------------------------------------ */
  /* URL partageable ?p=handle1,handle2,handle3                          */
  /* ------------------------------------------------------------------ */

  function hydrateFromUrl() {
    var match = window.location.search.match(/[?&]p=([^&]+)/);
    if (!match) return false;
    var handles = decodeURIComponent(match[1])
      .split(',')
      .map(function (h) {
        return h.trim();
      })
      .filter(Boolean)
      .slice(0, MAX);
    if (!handles.length) return false;

    return Promise.all(
      handles.map(function (h) {
        return fetchProduct(h);
      })
    ).then(function (results) {
      var items = [];
      results.forEach(function (d) {
        if (d && d.comparable === true) {
          items.push({
            handle: d.handle,
            id: d.id,
            title: d.title,
            vendor: d.vendor,
            image: d.image,
            url: d.url,
            addedAt: Date.now()
          });
        }
      });
      if (items.length) Store.write(items);
      return true;
    });
  }

  function shareUrl() {
    var handles = Store.read().map(function (i) {
      return i.handle;
    });
    return (
      window.location.origin +
      window.location.pathname +
      '?p=' +
      encodeURIComponent(handles.join(','))
    );
  }

  function copyLink(url) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(url)
        .then(function () {
          toast(STR.shared);
        })
        .catch(function () {
          window.prompt(STR.share || '', url);
        });
    } else {
      window.prompt(STR.share || '', url);
    }
  }

  /* Sur iOS le bouton devient « Partager » et affiche l'icone systeme. */
  function setupShareButtons() {
    if (!canNativeShare()) return;
    qsa('[data-cmp-share]').forEach(function (btn) {
      btn.classList.add('is-native');
      var label = btn.querySelector('[data-cmp-share-label]');
      if (label && STR.shareNative) label.textContent = STR.shareNative;
    });
  }

  /* ------------------------------------------------------------------ */
  /* Amorcage                                                            */
  /* ------------------------------------------------------------------ */

  function renderAll() {
    syncToggles();
    renderBar();
    qsa('[data-cmp-table]').forEach(function (el) {
      renderTable(el);
    });
  }

  function bind() {
    document.addEventListener(
      'click',
      function (e) {
        var target = e.target;
        if (!target || !target.closest) return;

        var toggleBtn = target.closest('[data-cmp-toggle]');
        if (toggleBtn) {
          e.preventDefault();
          e.stopPropagation();
          handleToggle(toggleBtn);
          return;
        }

        var removeBtn = target.closest('[data-cmp-remove]');
        if (removeBtn) {
          e.preventDefault();
          e.stopPropagation();
          Store.remove(removeBtn.getAttribute('data-handle'));
          return;
        }

        var clearBtn = target.closest('[data-cmp-clear]');
        if (clearBtn) {
          e.preventDefault();
          e.stopPropagation();
          Store.clear();
          return;
        }

        var shareBtn = target.closest('[data-cmp-share]');
        if (shareBtn) {
          e.preventDefault();
          var url = shareUrl();

          /* iOS : feuille de partage native. navigator.share doit etre appele
             de facon synchrone dans le gestionnaire de clic pour conserver
             l'activation utilisateur. */
          if (canNativeShare()) {
            try {
              navigator
                .share({ title: document.title, url: url })
                .catch(function () {
                  /* Annulation par l'utilisateur : on ne fait rien. */
                });
            } catch (err) {
              copyLink(url);
            }
            return;
          }

          copyLink(url);
        }
      },
      true
    );

    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-cmp-diff]')) {
        var root = e.target.closest('[data-cmp-table]');
        if (root) applyDiffFilter(root);
      }
    });

    document.addEventListener('compare:change', renderAll);

    window.addEventListener('storage', function (e) {
      if (e.key === KEY) {
        memory = null;
        renderAll();
      }
    });

    window.addEventListener('pageshow', function () {
      memory = null;
      renderAll();
    });

    /* Re-synchronisation apres re-rendu AJAX (filtres de collection, quick add...) */
    if (window.MutationObserver && document.body) {
      var moTimer;
      var observer = new MutationObserver(function (mutations) {
        var relevant = mutations.some(function (m) {
          return Array.prototype.some.call(m.addedNodes, function (n) {
            if (n.nodeType !== 1) return false;
            return (
              (n.matches && n.matches('[data-cmp-toggle]')) ||
              (n.querySelector && !!n.querySelector('[data-cmp-toggle]'))
            );
          });
        });
        if (!relevant) return;
        clearTimeout(moTimer);
        moTimer = setTimeout(syncToggles, 120);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  function init() {
    bind();
    setupShareButtons();
    var hydrated = hydrateFromUrl();
    if (hydrated && hydrated.then) {
      hydrated.then(renderAll);
    } else {
      renderAll();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.ArijeCompare = { store: Store, render: renderAll, nativeShare: canNativeShare };
})();
